import React, { useState } from 'react';
import { FiFileText, FiDownload, FiUser, FiMail, FiPhone, FiTarget } from "react-icons/fi";
import '../../styles/APSIS.css';

export default function APSISPage({ title, tag, description }) {
  return (
    <div className="apsis-page">
      {/* Hero */}
      <div className="apsis-hero">
         <div className="apsis-hero-content">
            <span className="apsis-tag">{tag || "EXPOSITION PROFESSIONNELLE"}</span>
            <h1>{title || "APSIS 2026"}</h1>
            <p>Salon International des Technologies de Sécurité et de la Gouvernance</p>
         </div>
      </div>

      <div className="apsis-content-grid">
        
        {/* Strategic Content Block */}
        <section className="apsis-text-section">
           <div className="section-header-v2">
              <span className="accent-line"></span>
              <h2>PRÉSENTATION STRATÉGIQUE</h2>
           </div>
           
           <div className="apsis-intro-text">
              <p className="lead-text-v2">
                {description || "APSIS 2026 se positionne comme le premier forum d'innovation technologique en Afrique et en Méditerranée dédié aux systèmes de sécurité et de cyber-défense."}
              </p>
              <p className="details-text-v2">
                Au carrefour des enjeux de souveraineté numérique et de gouvernance sécuritaire, 
                cette catégorie regroupe les acteurs clés capables de proposer des solutions cyber-physiques 
                adaptées aux défis complexes des infrastructures critiques du XXIe siècle.
              </p>
           </div>
        </section>

      </div>
    </div>
  );
}
